import { render, staticRenderFns } from "./OfferStatus.vue?vue&type=template&id=25fefe43&scoped=true&"
import script from "./OfferStatus.vue?vue&type=script&lang=js&"
export * from "./OfferStatus.vue?vue&type=script&lang=js&"
import style0 from "./OfferStatus.vue?vue&type=style&index=0&id=25fefe43&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fefe43",
  null
  
)

export default component.exports